import React, { Component } from "react";
import qs from "qs";
import successpayment from "../../assets/successpayment.svg";
import failedpayment from "../../assets/failedpayment.svg";
import CustomButton from "../../components/CustomButton";
import "../../App1.css";

export default class PaymentResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      }).errorMessage,
    };
  }

  onBack() {
    this.props.history.push("/Restaurants");
  }

  render() {
    return (
      <div className="paymentResultContainer">
        <img
          src={!this.state.errorMessage ? successpayment : failedpayment}
          alt=""
          style={{
            width: "50%",
            minWidth: "150px",
            maxHeight: "200px",
            objectFit: "contain",
          }}
        />
        <div
          style={{
            marginTop: "30px",
            color: !this.state.errorMessage ? "var(--brown1)" : "var(--red1)",
          }}
        >
          {!this.state.errorMessage
            ? "پرداخت شما با موفقیت انجام شد"
            : "پرداخت به علت زیر انجام نشد:"}
        </div>
        {!this.state.errorMessage && (
          <div className="paymentResultSubtitle">
            جهت بازگشت به صفحه اصلی دکمه زیر را کلیک کنید
          </div>
        )}
        {this.state.errorMessage && (
          <div className="paymentResultSubtitle">{this.state.errorMessage}</div>
        )}
        <div style={{ marginTop: "30px" }}>
          <CustomButton
            title="بازگشت به صفحه اصلی"
            minHeight="35px"
            onClick={this.onBack.bind(this)}
          />
        </div>
      </div>
    );
  }
}
